import React, { useEffect, useState } from 'react';
import api from '../../../../services/api';
import { IFinancial } from '../../../../shared/interfaces';
import { useToast } from '../../../../hooks/toast';
import {
  AButton,
  PageIntro,
  PageLayout,
  PagePanel,
} from '../../../../components';
import { ArrowLeftOutlined, PrinterOutlined } from '@ant-design/icons';
import { AccountsPayableReport } from '../../../../shared/reports/Financial/AccountPayable';
import { useNavigate } from 'react-router-dom';

const AccountsPayablePage: React.FC = () => {
  const [data, setData] = useState<IFinancial[]>([]);
  const { addToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get('/financials/reports/accounts-payable')
      .then((response) => {
        setData(response.data);
      })
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: 'Erro ao carregar relatório',
        });
      });
  }, [addToast]);

  return (
    <PageLayout>
      <PageIntro
        badge="Relatórios"
        icon={<PrinterOutlined />}
        title="Contas a pagar"
        description="Visualize o consolidado de contas a pagar com a nova estrutura visual das telas internas."
        actions={
          <AButton
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/financials')}
          >
            Voltar
          </AButton>
        }
      />
      <PagePanel>
        <AccountsPayableReport financials={data} />
      </PagePanel>
    </PageLayout>
  );
};
export default AccountsPayablePage;
